import React, { Fragment, useState, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Typography from "@material-ui/core/Typography";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import IconButton from "@material-ui/core/IconButton";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import { green } from "@material-ui/core/colors";
import KennitalaStep from "./KennitalaStep";
import FormStep from "./FormStep";
import PrintStep from "./PrintStep";
import StadfestaStep from "./StadfestaStep";
import { AppContext } from "store/AppContext";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(),
    marginBottom: theme.spacing(4)
  },
  stepper: {
    padding: theme.spacing()
  }
}));

const initialFormState = {
  kennitala: "",
  nafn: "",
  heimili: "",
  sveitarfelagsnumer: "",
  numerKjordaemis: null,
  kjorstadurNumer: null,
  kjordeild: null,
  atkvaediTegundId: 1,
  kosningId: null,
  athugasemd: "",
  adstodKjorstjori: false,
  adstodFulltrui: false,
  adstodBlindur: false,
  adstodHond: false,
  vottord: false,
  notandi: '',
  notandiKt: '',
  notandiEmbaettisnumer: null,
};

export default function MultistepForm() {
  const classes = useStyles();
  const context = useContext(AppContext);
  const [kjosandiInfo, setKjosandiInfo] = useState({});
  const [formState, setFormState] = useState(initialFormState);
  const [activeStep, setActiveStep] = useState(0);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const steps = [
    "Velja kjósanda",
    "Upplýsingaskráning",
    "Prenta fylgibréf / umslag",
    "Skrá atkvæði"
  ];

  useEffect(() => {
    setFormState(state => ({
      ...state,
      kosningId: context.activeKosning.get.id
    }));
  }, [setFormState, context.activeKosning.get]);

  const getStepContent = step => {
    switch (step) {
      case 0:
        return (
          <KennitalaStep
            setKjosandiInfo={setKjosandiInfo}
            handleNext={handleNext}
            resetForm={resetForm}
          />
        );
      case 1:
        return (
          <FormStep
            formState={formState}
            setFormState={setFormState}
            kjosandiInfo={kjosandiInfo}
            atkvaediOptions={context.atkvaediOptions.get}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );
      case 2:
        return (
          <PrintStep
            formState={formState}
            kjosandiInfo={kjosandiInfo}
            activeKosning={context.activeKosning.get}
            handleNext={handleNext}
            handleBack={handleBack}
          />
        );
      case 3:
        return (
          <StadfestaStep
            formState={formState}
            kjosandiInfo={kjosandiInfo}
            atkvaediOptions={context.atkvaediOptions.get}
            handleBack={handleBack}
            handleRestart={handleRestart}
            setSnackbarOpen={setSnackbarOpen}
          />
        );
      default:
        return <div>default</div>;
    }
  };

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
  };

  const resetForm = () => 
    setFormState({...initialFormState, kosningId: context.activeKosning.get.id });

  const handleRestart = () => {
    setActiveStep(0);
    resetForm();
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackbarOpen(false);
  };

  return (
    <Fragment>
      <Paper className={classes.paper}>
        <Typography variant="h6" align="center">
          Skráning atkvæða
        </Typography>
        <Stepper className={classes.stepper} activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps = {};
            const labelProps = {};
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Paper>
      {getStepContent(activeStep)}
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={handleSnackbarClose}
      >
        <SnackbarContent
          style={{ backgroundColor: green[600] }}
          message={
            <span
              id="success-snackbar"
              style={{ alignItems: "center", display: "flex" }}
            >
              <CheckCircleIcon style={{ marginRight: "8px" }} />
              <Typography>Atkvæði hefur verið skráð</Typography>
            </span>
          }
          action={
            <IconButton
              key="close"
              aria-label="close"
              color="inherit"
              onClick={handleSnackbarClose}
            >
              <CloseIcon />
            </IconButton>
          }
        />
      </Snackbar>
    </Fragment>
  );
}
